import React, { useState } from 'react';
import { Button, Grid, Typography, ListItemIcon, Menu, MenuItem } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Delete, Edit } from '@mui/icons-material';
import FAQHeader from './FAQHeader';
import "./CommonFAQ.scss";

function CommonFAQ(props) {
  const { heading, faq, handleEditFAQ, handleDeleteFAQ, isMobile ,hasViewMoreIcon} = props;
  const role = localStorage.getItem('role');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event, data) => {
    setSelectedIndex(data.id)
    setAnchorEl(event.currentTarget);

  };
  const handleEditClick = () => {
    const selectedItemData = faq.find(ele => ele.id === selectedIndex)
    handleEditFAQ(selectedItemData)
  }
  const handleDeleteClick = () => {
    const selectedItemData = faq.find(ele => ele.id === selectedIndex)
    handleDeleteFAQ(selectedItemData)
  }

  const handleClose = () => {
    setAnchorEl(null);
  }

  return (
    <Grid container
      direction='column'>
      {isMobile || role === 'adminCompany' ?
        ''  : <Grid>
          <FAQHeader />
        </Grid>}
      <Grid item container
        direction='column'>
        {isMobile  || role === 'adminCompany' ? '' :
          <Grid item className='marginTopLeft'>
            <span className="arrowIcon">
              <ArrowBackIosIcon /></span>
            <span className='headingAlign'>{heading}</span>
          </Grid>}
          <Grid item
            alignItems='center'
            justifyContent='center'
            className={role !== "adminCompany" ? 'marginLeftRight fontAlign' : 'fontAlign'}
          >
            {faq?.map((ele, idx) => (
              <Grid container key={idx} className='mt15 bgFaq'>
                <Grid item md={11.5}>
                  <Typography className='font18 fw600 '><span>{idx + 1}.
                  </span>{ele.question}</Typography>
                  <Typography className='font18 mt3'><span className='faqHyperlink' dangerouslySetInnerHTML={{__html:ele.answer}}></span></Typography>
                </Grid>
                {role === "adminCompany"  && hasViewMoreIcon ? <Grid item md={0.5}>

                  <Button onClick={(event) => handleClick(event, ele)}
                  >
                    <div className="colorBlack">{
                      <MoreVertIcon />}
                    </div>
                  </Button>
                  <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    className=''
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                  >
                    <MenuItem onClick={() => handleEditClick()} >
                      <ListItemIcon  >
                        <Edit fontSize="small" />
                      </ListItemIcon>
                      Edit
                    </MenuItem>
                    <MenuItem onClick={() => handleDeleteClick()}>
                      <ListItemIcon>
                        <Delete fontSize="small" />
                      </ListItemIcon>
                      Delete
                    </MenuItem>
                  </Menu>
                </Grid> : null}
              </Grid>

            ))}
          </Grid>
      </Grid>
    </Grid>


  )
}

export default CommonFAQ
